var _path, _path2, _path3, _line, _line2, _line3, _line4, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCardStatement = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.7171 39.4561V12.5798C37.7171 11.909 37.253 11.3652 36.6805 11.3652H12.9954C12.4229 11.3652 11.9589 11.909 11.9589 12.5798V39.4561H37.7171Z",
    stroke: "#051029",
    strokeWidth: 0.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.809 37.4503V10.5739C35.809 9.90312 35.3449 9.35938 34.7724 9.35938H11.0873C10.5148 9.35938 10.0508 9.90312 10.0508 10.5739V37.4503H35.809Z",
    fill: "#36B2AC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5965 9.60254H32.5542C33.1182 9.60254 33.5753 10.0833 33.5753 10.6764V37.4492H35.6176V10.6764C35.6176 10.0834 35.1604 9.60254 34.5965 9.60254Z",
    fill: "#15584F"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 11.9589,
    y1: 17.0107,
    x2: 24.361,
    y2: 17.0107,
    stroke: "#051029",
    strokeWidth: 0.75
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 11.9587,
    y1: 22.0273,
    x2: 24.3608,
    y2: 22.0273,
    stroke: "#051029",
    strokeWidth: 0.75
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 11.9587,
    y1: 27.043,
    x2: 31.0389,
    y2: 27.043,
    stroke: "#051029",
    strokeWidth: 0.75
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 11.9587,
    y1: 32.0596,
    x2: 31.0389,
    y2: 32.0596,
    stroke: "#051029",
    strokeWidth: 0.75
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0008 9.6126V9.08196C32.0008 8.57242 31.6067 8.15792 31.1221 8.15792H28.7786C28.294 8.15792 27.8999 8.57242 27.8999 9.08196V19.9683C27.8999 20.8638 28.5926 21.5923 29.4442 21.5923C30.2957 21.5923 30.9885 20.8638 30.9885 19.9683V12.4922C30.9885 12.1709 30.7399 11.9094 30.4343 11.9094C30.1287 11.9094 29.8801 12.1709 29.8801 12.4922V17.1602C29.8801 17.3826 29.7087 17.5629 29.4972 17.5629C29.2857 17.5629 29.1143 17.3826 29.1143 17.1602V12.4922C29.1143 11.7268 29.7064 11.1041 30.4343 11.1041C31.1622 11.1041 31.7543 11.7268 31.7543 12.4922V19.9683C31.7543 21.3079 30.718 22.3976 29.4442 22.3976C28.1704 22.3976 27.134 21.3079 27.134 19.9683V9.08196C27.134 8.12834 27.8718 7.35254 28.7786 7.35254H31.1221C32.029 7.35254 32.7667 8.12834 32.7667 9.08196V9.6126H32.0008Z",
    fill: "#051029"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCardStatement);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/CardStatement.cf06a590c486e43b680eaa2b3bdf6427.svg";